function on_resize(c,t){onresize=function(){clearTimeout(t);t=setTimeout(c,100)};return c};
(function($){

  $(document).ready(function(){
    //homepage hero slider
    $('#hero-slider').slick();
    
    // search drawer on header
    var $searchDrawer = $('#SearchDrawer');
    var isDrawerOpen = false;
    var $searchBtn = $('.button.search');
    var $toggleButton = $('.button.search a');
    var $toggletext = $toggleButton.children('span');
    $toggleButton.click(function(e) {
      e.preventDefault();
      isDrawerOpen = !isDrawerOpen;
        if ( isDrawerOpen ) {
          $toggletext.text('close search');
          $searchDrawer.slideDown(300);
        } else {
          $toggletext.text('search');
          $searchDrawer.slideUp(300);
        }
        $searchBtn.toggleClass('active');
      $searchDrawer.toggleClass('is-open');
    });

    //mobile menu toggle
    var $menuToggle = $('#menu-button');
    var $mobileNav = $('#mobile-navigation');
    var isMenuOpen = false;
    $menuToggle.click(function(e) {
      e.preventDefault();
      isMenuOpen = !isMenuOpen;
      if ( isMenuOpen ) {
        $mobileNav.slideDown(300);
      } else {
        $mobileNav.slideUp(300);
      }
      $mobileNav.toggleClass('is-open');
    });

    // collections pages
    var $pageheader = $('#page-header');
    var $headerimg = $pageheader.data('background');
    if ( $headerimg !== '' && typeof($headerimg) !== 'undefined' ) $pageheader.backstretch($headerimg);
  });


})(jQuery);